<template>
	<div id="app">
		<main>
			<v-app v-cloak :class="{ 'login-select': $route.name === 'login' }">
				<router-view name="login"></router-view>
				<div v-if="$route.name !== 'login'">
					<v-progress-linear v-bind:indeterminate="true" v-if="showProgress" class="progress-linear--global"></v-progress-linear>
					<router-view></router-view>
				</div>
				<v-snackbar v-bind:timeout="6000" v-bind:top="true" v-bind:right="true"
					v-model="snackbar.visible" v-bind:success="snackbar.success" v-bind:info="snackbar.info"
					v-bind:warning="snackbar.warning" v-bind:error="snackbar.error" v-bind:primary="snackbar.primary"
					v-bind:secondary="snackbar.secondary">
					{{ snackbar.message }}
					<v-btn flat class="dark--text" v-on:click.native="toggleSnackBar">Close</v-btn>
				</v-snackbar>
			</v-app>
		</main>
	</div>
</template>

<script>
import bus from './bus';

function onEventSnack(options) {
	this.snackbar = {
		...options,
	};
}

function created() {
	bus.$on('SNACK_BAR', onEventSnack.bind(this));
	bus.$on('show-progress', (result) => {
		this.showProgress = result;
	});
}

function toggleSnackBar() {
	this.snackbar.visible = !this.snackbar.visible;
}

export default {
	created,
	data() {
		return {
			snackbar: {
				visible: false,
				message: '',
			},
			showProgress: false,
		};
	},
	methods: {
		toggleSnackBar,
	},
	name: 'app',
};
</script>

<style lang="scss">
* {
	font-family: map-get($fonts, regular);
}

body {
	margin: 0;
	min-width: 320px;
}

.occupancy {
	.sortable-button {
		display: none;
	}

	.table-list {
		text-align: center;
	}

	input {
		display: none;
	}
}

input[type="number"] {
	&::-webkit-inner-spin-button,
	&::-webkit-outer-spin-button {
		display: none;
	}
}   

main {
	text-align: center;
}

.occupancy {
	.radio-group-transparent {
		.input-group__input {
			.icon {
				color: #85939e !important;
			}
		}
	}
}


header span {
	box-sizing: border-box;
	display: block;
	font-size: 20px;
	font-weight: 400;
	letter-spacing: .02em;
	line-height: 1;
	padding-top: 16px;
	position: relative;
}

a,
a:focus,
a:hover {
	text-decoration: none;
}

button,
button:hover,
button:focus {
	margin-bottom: 0px;
	outline: none;

	&:not(.btn--floating) {
		border-radius: 0px;
	}
}

button[disabled] {
	cursor: not-allowed;
	opacity: 0.6;
}

#app {
	-moz-osx-font-smoothing: grayscale;
	-webkit-font-smoothing: antialiased;
	font-family: map-get($fonts, regular);
}

li[data-divider]:after,
li[data-divider]:not(:last-child):after {
	color: map-get($colors, default-dark);
	display: inline-block;
	font-size: map-get($sizes, breadcrumb);
}

.navigation-drawer>.list .list--group__container {
	.sidebar-bg {
		.list__tile--active {
			.list__tile__title {
				color: map-get($colors, default-skyblue) !important;
			}
		}
	}
}

.text-capitalize {
	text-transform: capitalize;

	input {
		text-transform: capitalize;
	}
}

.display-flex {
	display: flex;
}

.display-inline-flex {
	display: inline-flex;
}

.align-items-center {
	align-items: center;
}

.list-unstyled {
	list-style: none;
}

.list__tile {
	&.list__tile--avatar {
		padding: 0px;
	}
}

.body-border {
	&-bottom {
		border-bottom: 1px solid map-get($colors, e-bg-icon);
	}

	&-dashed {
		&--bottom {
			border-bottom: 1px dashed map-get($colors, e-bg-icon);
		}
	}

	&-left {
		border-left: 1px solid map-get($colors, e-bg-icon);

		&-full {
			min-height: 100vh;
		}
	}

	&-right {
		border-right: 1px solid map-get($colors, e-bg-icon);

		&-full {
			min-height: 100vh;
		}
	}

	&-top {
		border-top: 1px solid map-get($colors, e-bg-icon);
	}
}

.button-default {
	@include default-button;

	&:hover {
		background-color: map-get($colors, default-skyblue);
		color: white;
		font-weight: map-get($weights, w-six);
	}
}

.little-subtitle-default {
	@include sub-title;
}

.container {
	background-color: map-get($colors, default-bg);

	&.fluid {
		padding: 0;
	}
}

.application--light {
	.input-group {
		&:not(.input-group--error) label {
			color: map-get($colors, default-button-color);
		}

		&.input-group {
			&--dirty .input-group__selections__comma:not(.input-group__selections__comma--active) {
				color: map-get($colors, default-button-color);
			}

			&--selection-controls label {
				font-size: map-get($sizes, thirdteen);
				left: 15px;
				top: 18px;
			}
		}

		&--selection-controls {
			color: map-get($colors, default-skyblue);
		}

		&.input-group--autocomplete {
			box-shadow: none;

			.input-group__selections {
				box-shadow: inset 0 2px 5px 0 rgba(0, 0, 0, .2);
				margin-right: 0px;
			}

			.input-group--select__autocomplete {
				margin-left: 0px;
			}

			.input-group__append-icon {
				background-color: map-get($colors, default-skyblue);
				color: white !important;
				font-size: 32px;
				transform: rotate(0) !important;
				width: 74px;
			}
		}

		&.input-switch {
			background-color: transparent;
			box-shadow: none;

			.input-group__input {
				background-color: transparent;
				box-shadow: none;

				.input-group--selection-controls__toggle {
					background-color: map-get($colors, border-plugin) !important;
					height: 16.7px;
					opacity: 1;
					width: 26.3px;

					&--active {
						background-color: map-get($colors, button-login) !important;
					}
				}

				.input-group--selection-controls__ripple {
					height: 10px;
					transform: translate3d(4px, -5px, 0);
					width: 10px;

					&:after {
						background-color: white !important;
						box-shadow: none;
						height: 10px;
						width: 10px;
					}

					&--active {
						transform: translate3d(10px, -5px, 0);

						&:after {
							transform: translate3d(-30%, -48%, 0);
						}
					}
				}
			}

			label {
				color: map-get($colors, dark);
				font-family: map-get($fonts, medium);
				font-size: map-get($colors, fourteen);
				font-weight: 500;
				margin-left: 5px;
				text-align: left;
				top: 19px;
			}
		}

		&.input-form-prefix {
			.input-group--text-field__prefix {
				background-color: transparent;
				box-shadow: none;
				color: map-get($colors, form-prefix);
				font-size: 14px;
				margin-left: 6px;
			}

			.input-group--text-field__prefix + input {
				margin-left: -30px;
				padding-left: 35px;
			}
		}
	}

	.icon {
		color: inherit;
	}

	.btn {
		margin: 0px;
		text-transform: none;

		&:not(.btn--floating) {
			border-radius: 0px;
			height: 38px;
		}

		&:not(.btn--icon):not(.btn--flat) {
			font-size: map-get($sizes, twelve);
			font-weight: normal;
			width: 100%;

			&.btn--raised {
				box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, .1);
			}

			&.btn-add {
				background-color: map-get($colors, button-create);
				box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, .1);
				max-width: 95px;

				.btn__content {
					color: white;
				}
			}

			&.btn-assign-tasks {
				background-color: map-get($colors, default-skyblue);
				box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .1);
				color: white;
				max-width: 145px;
			}

			&.btn-save {
				background-color: map-get($colors, default-skyblue);
				color: white;
				max-width: 122px;
			}

			&.btn-remove {
				background-color: map-get($colors, default-dark);
				color: white;
				max-width: 122px;
			}

			&.btn-cancel {
				background-color: map-get($colors, button-cancel);
				color: white;
				max-width: 122px;
			}

			&.btn-subsidiary-modal {
				background-color: white;
				box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, .18);
				height: 40px;
				min-width: 43px;
				width: 43px;
			}

			.btn__content {
				font-family: map-get($fonts, bold);
			}
		}
	}

	.pagination__item {
		border-radius: 0px;
		height: 33px;
		width: 33px;

		&--active {
			background: map-get($colors, default-skyblue);
		}
	}

	button.assign-room {
		background-color: map-get($colors, default-skyblue) !important;
		box-shadow: 0px 2px 4px 0px rgba($color: #000000, $alpha: .28);
		color: white;
		font-family: map-get($fonts, bold);
		font-size: 11px;
		height: 32px;

		.btn__content {
			padding: 0px !important;
			width: auto;
		}
	}
}

.filter-list {
	.btn {
		&:not(.btn--icon):not(.btn--flat) {
			font-size: map-get($sizes, fourteen);

			.btn__content {
				font-family: map-get($fonts, regular);
			}
		}
	}
}

.input-group {
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);
	max-height: 49px;
	min-height: 40px;
	padding: 0;

	&__details {
		flex: auto;
	}

	label {
		font-size: map-get($sizes, fourteen);
		margin: -14px 0px 0px 15px;
	}

	&__input {
		background-color: white;
		height: 40px;
	}

	&__selections {
		margin-left: 15px;

		.input-group__selections__comma {
			font-size: map-get($sizes, fourteen);
		}

		&__comma {
			padding-left: 15px;
		}
	}

	&--text-field {
		label {
			margin-left: 15px;
			top: 20px;
		}

		input {
			font-size: map-get($sizes, fourteen);
			height: auto;
			margin-left: 15px;
		}
	}

	.material-icons {
		width: 25px;
	}

	&.input-group--focused .input-group__append-icon,
	&.input-group--focused .input-group__prepend-icon {
		color: map-get($colors, arrow-icon);
	}

	&.time-standard-input {
		box-shadow: none;
		max-height: 31px;
		max-width: 101px;
		min-height: 31px;

		.input-group {
			&__input {
				box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, .16);
				height: 31px;

				input {
					max-width: 25px;

					&::-webkit-inner-spin-button,
					&::-webkit-outer-spin-button {
						display: none;
					}
				}
			}

			&--text-field__suffix {
				color: map-get($colors, time-text);
				font-size: map-get($sizes, fourteen);
			}

			&__details {
				display: none;
			}
		}

		&.stock {
			input {
				max-width: none;
			}
		}
	}

	&.select-housemaid-assign {
		max-height: none;
		max-width: 95px;
		min-height: 0px;

		.input-group {
			&__input {
				height: auto;
				min-height: 0;
				width: auto;
			}

			&__selections {
				margin-left: 0px;
				width: 68px;

				&__comma {
					padding-left: 8px;
				}
			}

			&__details {
				display: none;
			}
		}
	}

	&.input-border-inset {
		box-shadow: none;

		.input-group {
			&__details {
				display: none;
			}

			&__input {
				input {
					box-shadow: inset 0 2px 5px 0 rgba(0, 0, 0, .2);
					margin-left: 0px;
					padding-left: 15px;
				}
			}
		}

		&.price {
			.input-group {
				&--text-field__prefix {
					color: map-get($colors, dark);
					font-family: map-get($fonts, regular);
					font-size: map-get($sizes, fourteen);
					margin-left: 17px;
				}

				&__input {
					box-shadow: inset 0 2px 5px 0 rgba(0, 0, 0, .2);

					input {
						box-shadow: none;
						padding-left: 0px;

						&::-webkit-inner-spin-button,
						&::-webkit-outer-spin-button {
							display: none;
						}
					}
				}
			}
		}

		&.input-group--disabled {
			opacity: .6;
		}

		&.input-amount-prefix {
			.input-group--text-field__prefix {
				background-color: transparent;
				box-shadow: inset 3px 2px 5px 0px rgba(0, 0, 0, .2);
				color: rgba(0, 0, 0, .87);
				font-size: map-get($sizes, fourteen);
				margin: 0px;
				padding-left: 20px;

				& + input {
					box-shadow: inset -3px 2px 5px 0px rgba(0, 0, 0, .2);
					padding-left: 8px;
					padding-right: 8px;
				}
			}
		}
	}

	&.input-regular {
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, .18);

		.input-group {
			&__details {
				display: none;
			}

			&__input {
				input {
					margin-left: 0px;
					padding-left: 15px;
				}
			}
		}

		&.input-amount {
			input[readonly] {
				font-family: map-get($fonts, bold);
				font-size: map-get($sizes, sixteen);
				opacity: 1;
			}
		}

		.input-group--text-field__prefix {
			background-color: transparent;
			box-shadow: none;
			color: map-get($colors, form-prefix);
			font-size: 14px;
			margin-left: 15px;

			& + input {
				padding-left: 5px;
			}
		}
	}

	&.input-checkbox {
		box-shadow: none;

		label {
			color: map-get($colors, dark) !important;
			font-family: map-get($fonts, light);
			font-size: 14px !important;
		}

		.input-group {
			&__input {
				background-color: transparent;
			}
		}

		&.input-booking label {
			font-family: map-get($map: $fonts, $key: semibold);
			top: 19px;
		}
	}

	&.oval-select {
		.input-group {
			&__details {
				display: none;
			}

			&__input {
				height: 20px;
				min-height: 20px;
			}

			&__selections {
				margin-left: 0px;
				padding-left: 15px;

				&__comma {
					color: map-get($colors, room-status-filter) !important;
					font-family: map-get($fonts, semibold);
					font-size: map-get($sizes, twelve);
					padding-left: 0px;
				}
			}
		}

		label {
			color: map-get($colors, room-status-filter) !important;
			font-family: map-get($fonts, semibold);
			font-size: map-get($sizes, twelve);
			height: 23px;
			line-height: 23px;
			top: 13px;
		}
	}

	&.input-languages {
		&.input-group {
			align-content: flex-end;

			label {
				left: 30px;
				margin: 0px;
				position: relative;
				top: 36px;

				img {
					margin-right: 8px;
				}

				span {
					vertical-align: super;
				}
			}
		}
	}

	&.input-textarea {
		max-height: 100%;

		&.input-note {
			.input-group__input {
				padding-top: 10px;
			}
		}

		.input-group {
			&__details {
				display: none;
			}

			&__input {
				border: none !important;
				border-radius: 0px;
				box-shadow: inset 0px 1px 4px 0px rgba(0, 0, 0, .2);
				height: auto;
				padding: 13px 0px 0px 13px;

				textarea {
					color: map-get($colors, dark);
					font-size: 14px;
				}
			}
		}
	}

	input[readonly] {
		opacity: .5;
	}

	&.input-label {
		input {
			padding-left: 0px !important;
			text-align: center;

			&[readonly] {
				opacity: 1;
			}
		}
	}

	&.sale-radio-button {
		box-shadow: none;

		label {
			color: map-get($map: $colors, $key: label-sales) !important;
		}
	}
}

.radio-group {
	box-shadow: none;

	.input-group__details {
		display: none;
	}
}

.calendar-range {
	box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, .18);
	margin: 0px 1px !important;

	.input-group {
		box-shadow: none;

		input {
			color: map-get($colors, realtime-label);

			&[readonly] {
				opacity: 1;
			}
		}
	}
}

.application--light .pagination__item {
	color: map-get($colors, -label);
}

.application--light .pagination__item--active {
	 background-color: map-get($colors, default-skyblue);
	 color: white;
}

.room-filters {
	.input-group {
		max-height: 32px;
		max-width: 111px;
		min-height: 23px;
		min-width: 123px;
		padding: 0;

		&__input {
			background-color: white;
			border: 2px solid gray;
			border-radius: 15px;
			box-shadow: none;
			color: gray;
			font-size: 12px;
			margin: 3px 6.5px;
			max-height: 23px;
			max-width: 111px;
			min-height: 23px;
			min-width: 111px;
			width: 111px;
		}
	}

	label {
		font-size: 12px;
		font-weight: 500;
		margin: -19px 0 0 15px;
		max-height: 23px;
		max-width: 103px!important;
	}
}

.mx-a {
	margin: 0 auto !important;
}

.toolbar--hk {
	box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .1);

	&>.toolbar__content {
		height: 46px;
	}

	&+main {
		padding-top: 46px;
	}
}

.list--hk {
	&.list--dense {
		.list__tile {
			font-size: map-get($sizes, fifteen);

			&:not(.list__tile--avatar) {
				height: 45px;
				padding: 0 17px;
			}
		}

		.sidebar-bg {
			.list__tile {
				font-size: map-get($sizes, fourteen);

				&:not(.list__tile--avatar) {
					padding: 0 0 0 49px;
				}

				&__title {
					color: map-get($colors, menu-text);
				}

				&--active {
					color: map-get($colors, default-skyblue) !important;
				}
			}
		}
	}
}

.application--toolbar>main>.container {
	background: #efefef;
	min-height: calc(100vh - 92px);
	padding: 19px 20px;
}

.sprite {
	&-menu {
		background-image: url('/static/img/sprites/spritesheet-menu.png');
		background-repeat: no-repeat;

		&.dashboard,
		&.dashboard-sales {
			background-position: -33px -5px;
			height: 15px;
			width: 18px;
		}

		&.housemaid {
			background-position: -31px -40px;
			height: 21px;
			width: 16px;
		}

		&.room {
			background-position: -131px -29px;
			height: 14px;
			width: 18px;
		}

		&.product {
			background-position: -90px -96px;
			height: 19px;
			width: 9px;
		}

		&.laundry {
			background-position: -81px -40px;
			height: 17px;
			width: 14px;
		}

		&.lf {
			background-position: -57px -67px;
			height: 17px;
			width: 16px;
		}

		&.problem {
			background-position: -61px -94px;
			height: 17px;
			width: 19px;
		}

		&.user {
			background-position: -133px -105px;
			height: 17px;
			width: 14px;
		}

		&.planning {
			background-position: -5px -94px;
			height: 17px;
			width: 17px;
		}

		&.settings {
			background-position: -129px -79px;
			height: 16px;
			width: 16px;
		}

		&.typecleaning {
			background-image: url('/static/img/menu-cleaning.svg');
			background-position: -2px 0px;
			background-size: cover;
			height: 19px;
			width: 19px;
		}

		&.minibar {
			background-image: url('/static/img/menu-minibar.svg');
			background-position: -2px 0px;
			background-size: cover;
			height: 19px;
			width: 19px;
		}

		&.transfers {
			background-image: url('/static/img/menu-transfer.svg');
			background-size: cover;
			height: 19px;
			width: 19px;
		}

		&.config {
			background-image: url('/static/img/menu-config.svg');
			background-size: cover;
			height: 19px;
			width: 19px;
		}
	}

	&-extra {
		background-image: url('/static/img/sprites/spritesheet-extras.png');

		&.settings {
			background-position: 95% 4%;
			height: 19px;
			width: 19px;
		}
	}

	&-breadcrumb {
		background-image: url('/static/img/sprites/spritesheet-breadcrumb.png');
		background-repeat: no-repeat;
		margin-right: 6px;

		&.dashboard,
		&.dashboard-sales {
			background-position: -5px -5px;
			height: 17px;
			width: 21px;
		}

		&.housemaids {
			background-position: -36px -5px;
			height: 24px;
			width: 18px;
		}

		&.laundry {
			background-position: -64px -5px;
			height: 17px;
			width: 14px;
		}

		&.lostandfound {
			background-position: -5px -32px;
			height: 17px;
			width: 16px;
		}

		&.planning {
			background-position: -64px -32px;
			height: 17px;
			width: 17px;
		}

		&.problem-report {
			background-position: -31px -39px;
			height: 17px;
			width: 19px;
		}

		&.products {
			background-position: -5px -59px;
			height: 19px;
			width: 9px;
		}

		&.rooms {
			background-position: -60px -59px;
			height: 16px;
			width: 21px;
		}

		&.states {
			background-position: -88px -5px;
			height: 16px;
			width: 16px;
		}

		&.users {
			background-position: -91px -31px;
			height: 20px;
			width: 16px;
		}

		&.settings {
			background-image: url('/static/img/breadcrumb-cleaning.svg');
			background-size: cover;
			height: 19px;
			width: 17px;
		}

		&.minibar {
			background-image: url('/static/img/breadcrumb-minibar.svg');
			background-size: cover;
			height: 19px;
			width: 17px;
		}

		&.transfers {
			background-image: url('/static/img/breadcrumb-transfer.svg');
			background-size: cover;
			height: 19px;
			width: 19px;
		}

		&.configuration {
			background-image: url('/static/img/breadcrumb-config.svg');
			background-size: cover;
			height: 19px;
			width: 19px;
		}
	}

	&-states {
		background-image: url('/static/img/sprites/spritesheet-states.svg');
		background-repeat: no-repeat;
		background-size: cover;

		&.booking {
			background-position: 0px 0;
			height: 22px;
			width: 20px;
		}

		&.cleandeep {
			background-position: -27px 0;
			height: 19px;
			width: 21px;
		}

		&.dirty {
			background-position: -85px 0px;
			height: 26.8px;
			width: 12.6px;
		}

		&.gym {
			background-position: -63px 0;
			height: 14px;
			width: 20px;
		}

		&.locked {
			background-position: -127px 0;
			height: 16.7px;
			width: 13.2px;
		}

		&.outofservice {
			background-position: -141px 0;
			height: 15.7px;
			width: 15.3px;
		}

		&.turnover {
			background-position: -178px 0;
			height: 17px;
			width: 17px;
		}

		&.maintenance {
			background-position: -198px 0;
			height: 16.5px;
			width: 16.5px;
		}

		&.indeterminate {
			background-image: url('/static/img/sprites/spritesheet-icons.png');
			background-position: -5px -4px;
			background-size: auto;
			height: 16.6px;
			width: 15.8px;
		}
	}

	&-icons {
		background-image: url('/static/img/sprites/spritesheet-icons.png');
		background-repeat: no-repeat;
		display: inline-block;
		font-size: inherit;
		letter-spacing: inherit;
		line-height: inherit;
		padding-top: 0px;

		&.type-clean {
			background-position: -40px -48px;
			height: 13px;
			width: 11px;
		}

		&.date {
			background-position: -30px -5px;
			height: 12px;
			width: 9px;
		}

		&.time-done,
		&.time-standard {
			background-position: -40px -25px;
			height: 13px;
			width: 13px;
		}

		&.supervisor {
			background-position: -49px -5px;
			height: 11px;
			width: 7px;
		}
	}
}

.sidebar-bg:hover,
.sidebar-bg.active {
	.sprite-menu {

		&.dashboard,
		&.dashboard-sales {
			background-position: -5px -5px;
		}

		&.housemaid {
			background-position: -5px -40px;
		}

		&.room {
			background-position: -129px -5px;
		}

		&.product {
			background-position: -110px -67px;
		}

		&.laundry {
			background-position: -57px -40px;
		}

		&.lf {
			background-position: -105px -40px;
		}

		&.problem {
			background-position: -32px -94px;
		}

		&.user {
			background-position: -109px -105px;
		}

		&.planning {
			background-position: -83px -67px;
		}

		&.settings {
			background-position: -131px -53px;
		}

		&.typecleaning {
			background-image: url('/static/img/menu-cleaning-active.svg');
		}

		&.minibar {
			background-image: url('/static/img/menu-minibar-active.svg');
		}

		&.transfers {
			background-image: url('/static/img/menu-transfer-active.svg');
		}

		&.config {
			background-image: url('/static/img/menu-config-active.svg');
		}
	}

	.list__tile__title {
		color: map-get($colors, default-skyblue) !important;
	}
}

.list--group__header {
	.sprite-menu {

		&.housekeeping {
			background-position: -95px -5px;
			height: 25px;
			width: 24px;
		}

		&.clerkinn {
			background-image: url('/static/img/menu-clerkinn.svg');
			background-position: 0 0;
			background-size: cover;
			height: 25px;
			width: 24px;
		}

		&.config {
			background-image: url('/static/img/menu-config.svg');
			background-size: cover;
			height: 19px;
			width: 19px;
		}
	}

	.list__tile__title {
		color: map-get($colors, menu-text) !important;
	}

	&:hover {
		.sprite-menu {

			&.housekeeping {
				background-position: -61px -5px;
			}

			&.clerkinn {
				background-image: url('/static/img/menu-clerkinn-active.svg');
			}

			&.config {
				background-image: url('/static/img/menu-config-active.svg');
			}
		}

		.list__tile__title {
			color: white !important;
		}
	}

	&--active {
		.sprite-menu {

			&.housekeeping {
				background-position: -61px -5px;
			}

			&.clerkinn {
				background-image: url('/static/img/menu-clerkinn-active.svg');
			}

			&.config {
				background-image: url('/static/img/menu-config-active.svg');
			}
		}

		.list__tile__title {
			color: white !important;
		}
	}
}

ul.breadcrumbs {
	border-bottom: 1px solid map-get($colors, e-bg-icon);
	justify-content: flex-start;
	padding: 2px 6px;

	li:last-child a,
	.breadcrumbs__item {
		color: map-get($colors, default-dark);
		font-size: map-get($sizes, breadcrumb);
	}

	.breadcrumbs__item {
		padding: 0px 7px 0px 14px;
		vertical-align: middle;
	}

	li:last-child:not(:first-child) a {
		padding: 0px;
	}

	&.housemaid-breadcrumb {
		li[data-divider]:after,
		li[data-divider]:not(:last-child):after {
			position: relative;
			top: -3px;
		}
	}
}

table.table-list {
	text-align: left;

	thead th {
		font-family: map-get($fonts, regular) !important;

		a {
			.icon-delete,
			.icon-export {
				cursor: pointer;
			}
		}
	}

	tbody tr:hover td:not(.td-employee) {
		font-family: map-get($fonts, medium) !important;

		&.options-column {
			&.options-column-housemaids,
			&.options-column-transfers {
				border-right: 1px solid map-get($colors, default-skyblue);
			}
		}
	}

	tbody tr td {
		.icon.image-icon {
			height: auto;
			margin-left: 0px !important;
			margin-top: -4px;
			vertical-align: initial;
		}

		&:not(.td-employee).active {
			border-bottom: 1px solid map-get($colors, default-skyblue);
			border-top: 1px solid map-get($colors, default-skyblue);
			color: map-get($colors, bg-chart);
			font-family: map-get($fonts, medium);

			&.options-column {
				&.options-column-housemaids,
				&.options-column-transfers {
					border-right: 1px solid map-get($colors, default-skyblue);
				}
			}

			& + .options-column:not(.active) {
				border-bottom: 1px solid map-get($colors, default-skyblue);
				border-right: 1px solid map-get($colors, default-skyblue);
				border-top: 1px solid map-get($colors, default-skyblue);
			}

			&:first-child {
				border-left: 1px solid map-get($colors, default-skyblue);
			}
		}
	}

	.link-to {
		cursor: pointer;
	}

	&.no-selectable-table {
		thead th {
			&:first-child {
				width: auto !important;
			}
		}

		tbody td {
			&:first-child {
				width: auto !important;
			}
		}
	}

	&.no-search-table {
		thead th {
			&:last-child {
				width: auto !important;
			}
		}
	}

	&.table-custom-options {
		.options-column {
			display: none;
		}

		thead {
			tr {
				th {
					&:last-child {
						padding-right: 17.5px;
						width: 170px;
					}
				}
			}
		}
	}

	&.table-housemaid-assign {
		border: 1px solid map-get($colors, default-bg);
	}

	.options-column .options-item {
		height: 19px !important;
		line-height: 18px;
	}
}

.semibold-blue-title {
	&-20 {
		color: map-get($colors, blue-title);
		font-family: map-get($fonts, semibold);
		font-size: map-get($sizes, twenty);
		margin: 0px;
	}

	&-30 {
		color: map-get($colors, blue-title);
		font-family: map-get($fonts, medium);
		font-size: map-get($sizes, maintitle);
		margin: 0px;
	}
}

.sucursal-select,
.building-select,
.inline-filter-list {
	display: inline-flex;
	vertical-align: middle;
}

.sucursal-select,
.building-select {
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .18);
	max-height: 40px;
	max-width: fit-content;
}

.save-btn {
	background-color: map-get($colors, default-skyblue) !important;
	box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1) !important;
	height: 38px;
	margin: 0;
	width: 164px;
	.btn__content {
		font-family: map-get($fonts, bold) !important;
		font-size: map-get($sizes, twelve);
	}
}

.input-form,
.input-form:focus {
	background-color: white;
	box-shadow: inset 0 2px 5px 0 rgba(0, 0, 0, 0.2);
	height: 40px;
	outline: none;
	padding-left: 15px;
	width: 100%;

	&::placeholder {
		color: map-get($colors, dark);
	}
}

.tab-housekeeping {
	.tabs__container {
		height: 44px;
		right: 0;
		width: auto;
	}

	.tabs__item {
		color: map-get($colors, default-button-color) !important;
		margin: 0 14px;
		padding: 0px;
		text-transform: capitalize;

		&.tabs__item--active {
			color: map-get($colors, default-dark) !important;
		}
	}
}

.select-slots-housekeeping {
	.input-group {
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .18);
		max-height: 100%;
		max-width: 100%;

		&__input {
			height: 52px;
		}

		&__details {
			display: none;
		}

		&__selections {
			color: map-get($colors, default-dark);
			justify-content: space-between;

			.chip-status {
				height: 33.5px;
				width: 83px;

				&.medium {
					margin: 0px;

					label {
						color: white !important;
						height: 33.5px;
						margin: 0px;
						max-width: 100%;
						overflow: visible;
						text-align: center;
						top: auto;
						width: 82.2px;
					}

					.sprite-states {
						&.booking {
							background-position: 0px 0;
							height: 10.3px;
							width: 9.3px;
						}

						&.cleandeep {
							background-position: -21px 0;
							height: 12.3px;
							width: 12.2px;
						}

						&.dirty {
							background-position: -70px 0px;
							height: 20.9px;
							width: 7.7px;
						}

						&.gym {
							background-position: -49px 0;
							height: 11px;
							width: 18px;
						}

						&.locked {
							background-position: -86px 0;
							height: 11.6px;
							width: 10.4px;
						}

						&.outofservice {
							background-position: -91px 0;
							height: 10.1px;
							width: 10.7px;
						}

						&.turnover {
							background-position: -124px 0;
							height: 11.8px;
							width: 11.7px;
						}

						&.maintenance {
							background-position: -145px 0;
							height: 12.1px;
							width: 12.3px;
						}
					}
				}

				&.large {
					margin: 0px;
				}
			}

			.chip-icon {
				height: 33.5px;
				right: -3px;
				width: 19.9px;
			}
		}

		label {
			color: map-get($colors, default-dark) !important;
			height: 44px;
			line-height: 44px;
		}

		&--text-field.input-group--dirty.input-group--select label,
		&--text-field.input-group--dirty:not(.input-group--textarea) label {
			transform: none;
		}
	}
}

.menu__content {
	transform: translateZ(0);

	.card {
		contain: content;

		.list {
			padding: 12px 0px;

			&__tile {
				color: map-get($colors, default-label) !important;
				font-size: map-get($sizes, fourteen);
				padding: 0px 12px;

				&:hover {
					color: map-get($colors, default-dark) !important;
				}

				&--avatar {
					height: 45px;
				}

				&--active {
					color: map-get($colors, default-dark) !important;
				}

				.chip-status {
					height: 33.5px;
					width: 83px;

					&.medium {
						label {
							color: white !important;
							height: 33.5px;
							margin: 0px;
							max-width: 100%;
							overflow: visible;
							text-align: center;
							top: auto;
							width: 82.2px;
						}

						.sprite-states {
							&.booking {
								background-position: 0px 0;
								height: 10.3px;
								width: 9.3px;
							}

							&.cleandeep {
								background-position: -21px 0;
								height: 12.3px;
								width: 12.2px;
							}

							&.dirty {
								background-position: -70px 0px;
								height: 20.9px;
								width: 7.7px;
							}

							&.gym {
								background-position: -49px 0;
								height: 11px;
								width: 18px;
							}

							&.locked {
								background-position: -86px 0;
								height: 11.6px;
								width: 10.4px;
							}

							&.outofservice {
								background-position: -91px 0;
								height: 10.1px;
								width: 10.7px;
							}

							&.turnover {
								background-position: -124px 0;
								height: 11.8px;
								width: 11.7px;
							}

							&.maintenance {
								background-position: -145px 0;
								height: 12.1px;
								width: 12.3px;
							}
						}
					}
				}

				.chip-icon {
					height: 33.5px;
					right: -3px;
					width: 19.9px;
				}
			}
		}
	}

	&--select {
		.input-group {
			box-shadow: none;
		}

		.input-group__input {
			background-color: transparent;
		}
	}
}

.medium {
	.sprite-states {

		&.booking {
			background-position: -1px 0;
			height: 13.1px;
			width: 12.3px;
		}

		&.cleandeep {
			background-position: -27px 0;
			height: 12.3px;
			width: 12.2px;
		}

		&.dirty {
			background-position: -63px 0px;
			height: 20.9px;
			width: 7.7px;
		}

		&.gym {
			background-position: -63px 0;
			height: 14px;
			width: 20px;
		}

		&.locked {
			background-position: -125px 0;
			height: 11.6px;
			width: 9.4px;
		}

		&.outofservice {
			background-position: -143px 0;
			height: 10.1px;
			width: 10.7px;
		}

		&.turnover {
			background-position: -178px 0;
			height: 11.8px;
			width: 11.7px;
		}

		&.maintenance {
			background-position: -198px 0;
			height: 12.1px;
			width: 12.3px;
		}
	}
}

.divider-full {
	margin: 15px 0px 15px -20px;
	width: calc(100% + 40px);
}

.room-detail .medium .chip-icon {
	top: 1px;
}

textarea,
textarea:focus {
	outline: none;
	padding: 15px 10px;
	resize: none;
}

.login-body-container {
	.input-group {
		box-shadow: none;
		min-height: 22px;

		&:not(.input-group--error) label {
			color: map-get($colors, default-button-color);
			margin-left: 0px;
			top: 13px;
		}

		&__input {
			height: auto;
			min-height: 24px;
		}

		&--text-field {
			align-self: center;
			color: map-get($colors, default-button-color);
			font-size: map-get($sizes, fourteen);
			margin-left: 0px;

			&:first-child {
				margin-bottom: 10px;
			}

			input {
				align-self: flex-end;
				height: 20px;
				margin-left: 0px;
			}

			&.input-group--prepend-icon {

				&.input-group--error {
					label {
						left: 24px;
						top: 14px;
					}
				}

				.input-group__details {
					&:after,
					&:before {
						margin-left: 0px;
						max-width: 100%;
					}
				}
			}
		}

		&.input-group--focused:not(.input-group--error) .input-group__prepend-icon {
			color: map-get($colors, default-skyblue) !important;
		}

		&__prepend-icon {
			align-self: flex-end;
			color: map-get($colors, default-button-color) !important;
			font-size: 22px;
			height: 18px;
			width: auto;
		}

		&__append-icon {
			color: map-get($colors, green-switch) !important;
			font-size: 13px;
			width: auto;
		}
	}

	.remember-data {
		.input-group__input {
			.material-icons.icon {
				font-size: map-get($sizes, fifteen);

				&:not(.input-group__icon-cb) {
					display: none;
				}
			}
		}
	}

	.button-login {
		&:not(.btn--icon):not(.btn--flat) .btn__content {
			color: white;
			font-size: map-get($sizes, sixteen);
		}
	}
}

.login-footer {
	.input-group {
		&__input {
			background-color: transparent;
			min-width: auto;
		}

		&.input-group--dirty .input-group__selections__comma {
			font-size: map-get($sizes, fifteen);
			padding-left: 0px;

			&:not(.input-group__selections__comma--active) {
				color: white;
			}
		}

		&__selections {
			margin-left: 0px;
		}

		label {
			font-family: map-get($fonts, regular);
			font-size: map-get($sizes, fifteen);
		}

		&--text-field label {
			top: 18px;
		}

		&:not(.input-group--error):not(.input-group--focused):not(.input-group--disabled) .input-group__input .input-group__append-icon,
		&:not(.input-group--error):not(.input-group--focused):not(.input-group--disabled) .input-group__input .input-group__prepend-icon {
			color: white;
		}

		&.input-group--focused {
			.input-group__append-icon,
			.input-group__prepend-icon {
				color: white;
			}
		}
	}
}

.login-select {
	.menu__content {
		bottom: 45px;
		left: auto !important;
		right: 15px;
		top: auto !important;
	}

	.menu__content,
	.card,
	.list {
		background: transparent;
		background-color: transparent;
		border-radius: 0px;
		box-shadow: none;
		color: white;
	}

	.menu__content .card .list {
		padding: 0px;

		&__tile {
			color: white !important;
			font-size: map-get($sizes, fifteen);
			height: 40px;
			padding: 0px;

			.list__tile__title {
				padding-left: 10px;
			}

			&--active {
				display: none;
			}
		}
	}
}

.new-state-container {
	.large.topProperty .chip-icon {
		top: 1px;
	}
}

.progress-linear {
	&--global {
		margin: 0px;
		position: fixed;
		z-index: 7;
	}
}

.menu-color-picker {
	display: flex;
	flex-direction: column;
	padding: 10px 14px 27px 15px;
}

.btn-danger {
	align-self: flex-end;
	background-color: map-get($colors, calendary-red);
	border-radius: 100px;
	color: white;
	font-family: map-get($fonts, semibold);
	font-size: 12px;
	height: 23px;
	width: 64px;
}

.vc-chrome {
	border: 1px solid map-get($colors, default-bg);
	border-radius: none !important;
	box-shadow: none !important;
}

.filter-select-billing.input-group {
	max-height: 31px;
	min-height: 31px;
}

.filter-select-billing {
	.input-group__input {
		height: auto;
	}
	.input-group {
		&__details {
			display: none;
		}

		&__selections {
			margin-left: 0px;
			margin-right: 10px;
			padding-left: 15px;

			&__comma {
				padding-left: 0px;

				&:not(.input-group__selections__comma--active) {
					color: map-get($colors, dark) !important;
				}
			}
		}
	}
}

.filter-select {
	&.input-group {
		&:not(.input-group--error) label {
			color: map-get($colors, dark);
		}
	}

	.input-group {
		&__details {
			display: none;
		}

		&__selections {
			margin-left: 0px;
			margin-right: 8px;
			padding-left: 15px;

			&__comma {
				padding-left: 0px;

				&:not(.input-group__selections__comma--active) {
					color: map-get($colors, dark) !important;
				}
			}
		}
	}

	&.filter-select-currency {
		.input-group {
			&__prepend-icon {
				background-color: map-get($colors, bg-coin);
				border-radius: 100%;
				color: white !important;
				font-family: map-get($fonts, bold);
				font-size: map-get($sizes, fourteen);
				height: 23px;
				line-height: 23px;
				margin: 8.5px 10px 0px;
				min-width: 23px;
				padding-left: 4px;
			}

			&__selections {
				border-left: 1px solid map-get($colors, calendar-border);
			}
		}

		&.usd {
			.input-group {
				&__prepend-icon {
					padding-left: 7px;
				}
			}
		}
	}

	&.filter-select-indicator {
		position: absolute;
		width: 120px;
		z-index: 1;

		.input-group__selections {
			margin-right: 0px;
			padding-left: 10px;
		}
	}

	&.filter-header-calendar {
		label {
			top: 15px;
		}
	}

	&.select-roomtype {
		box-shadow: none;
		max-height: 27px;
		min-height: 1px;

		.input-group__input {
			background-color: white;
			height: 28px;
			min-height: 28px;
		}

		.input-group__selections {
			justify-content: center;
			margin-right: 0px;
			padding-left: 7px;

			&__comma {
				color: dark !important;
				font-family: map-get($fonts, medium);
				font-size: map-get($sizes, thirdteen);
				padding-right: 0px;
			}
		}

		.material-icons {
			color: dark !important;
			font-size: 17px;
			padding: 0 3px;
			width: 13px;
		}

		label {
			color: dark !important;
			font-size: map-get($sizes, thirdteen);
			height: 13px;
			line-height: 13px;
			margin-left: 0px;
			max-width: 95%;
			text-align: center;
			top: 21px;
		}
	}

	&.input-group--disabled {
		opacity: .6;
	}

	&.filter-select-main {
		.input-group__selections__comma {
			color: map-get($map: $colors, $key: default-dark);
			font-size: 23px;
			margin: 0 auto;
		}

		&.input-group.input-group--autocomplete {
			box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .18);
		}

		&.input-group.input-group--autocomplete .input-group__selections {
			box-shadow: none;
		}

		&.input-group.input-group--autocomplete .input-group__append-icon {
			background-color: transparent;
			color: rgba(0, 0, 0, .54) !important;
			font-size: 24px;
			transform: none !important;
			width: 25px;
		}
	}

	&.filter-select-autocomplete {
		&.input-group.input-group--autocomplete {
			box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .18);
		}

		&.input-group.input-group--autocomplete .input-group__selections {
			box-shadow: none;
		}

		&.input-group.input-group--autocomplete .input-group__append-icon {
			background-color: transparent;
			color: rgba(0, 0, 0, .54) !important;
			font-size: 24px;
			transform: none !important;
			width: 25px;
		}

		.input-group__selections__comma + input {
			display: none;
		}
	}

	&.filter-select-multiple {
		&.input-group {
			max-height: none;
		}

		.input-group__input {
			height: auto;
		}
	}
}

.menu__content--autocomplete {
	.list .checkbox.input-group--selection-controls {
		box-shadow: none;

		.input-group__input {
			background-color: transparent;
			box-shadow: none;
		}
	}
}

.filters-by-time {
	.btn:not(.btn--icon):not(.btn--flat) {
		.btn__content {
			font-family: map-get($fonts, regular);
		}

		&.active .btn__content {
			font-family: map-get($fonts, bold);
		}
	}
}

.menu-date-picker {
	.input-group {
		&--hide-details .input-group__details {
			display: none;
		}

		&__prepend-icon {
			background-color: map-get($colors, calendary-red);
			color: white !important;
			padding: 1px 0px 0px 8px;
		}
	}

	&.menu-form {
		border-bottom-right-radius: 6px;
		border-top-right-radius: 6px;

		.input-group,
		.input-group__input {
			border-bottom-right-radius: 6px;
			border-top-right-radius: 6px;
		}

		.input-group__append-icon {
			background-color: map-get($colors, default-skyblue);
			border-bottom-right-radius: 6px;
			border-top-right-radius: 6px;
			color: white !important;
			font-size: 30px;
			width: 57px;
		}
	}

	.product-date-picker {
		.input-group__prepend-icon {
			background-color: map-get($colors, default-skyblue);
		}
	}

	&.menu--disabled {
		opacity: .6;
	}
}

.snack {
	.btn--flat {
		color: white;
	}
}

.label-medium {
	color: map-get($colors, default-dark);
	font-family: map-get($fonts, medium);
	font-size: map-get($sizes, fourteen);
}

.control {
	.input-group {
		&__selections {
			margin-left: 0px;
		}

		&__details {
			display: none;
		}
	}
}

.title-form {
	color: map-get($colors, dark);
	font-family: map-get($fonts, medium);
	font-size: map-get($colors, fourteen);
	font-weight: 500;
	padding-top: 10px;
	text-align: left;
}

.btn-toggle {
	&.toggle-subsidiaries {
		background-color: transparent;
		box-shadow: none;
		display: block;
		min-width: 100%;

		.btn {
			background-color: white !important;
			border-radius: 0px;
			box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, .1) !important;
			color: map-get($colors, dark);
			margin-bottom: 15px;
			margin-right: 15px;
			opacity: 1;
			text-transform: capitalize;
			width: calc((100% - 30px) / 3) !important;

			&:nth-child(3n) {
				margin-right: 0px;
			}

			&.primary {
				background-color: map-get($colors, default-skyblue) !important;
				border-color: map-get($colors, default-skyblue) !important;

				.btn__content {
					color: white;
				}
			}

			&__content {
				color: map-get($colors, dark);
				font-family: map-get($fonts, regular) !important;
			}
		}
	}
}

.v-toggle {
	border: 0px !important;

	&-circle {
		box-shadow: none !important;
	}
}

.close-modal {
	color: map-get($colors, header-dark);
	cursor: pointer;
	position: absolute;
	right: 15px;
	top: 20px;
}

.input-map,
.input-map:focus {
	background-color: white;
	box-shadow: inset 0 2px 5px 0 rgba(0, 0, 0, .2);
	height: 40px;
	outline: none;
	padding: 0px 15px;
	text-align: left;
	width: 100%;
}

.form-button {
	.btn {
		.btn__content {
			&:before {
				background-color: transparent !important;
			}
		}
	}
}

.input-form-select {
	input {
		padding-left: 130px !important;
	}

	&.input-group--disabled {
		opacity: .6;
	}
}

.label-form {
	color: map-get($colors, dark);
	font-family: map-get($fonts, light);
	font-size: 14px;
}

.white-color {
	
	.label-form {
		color: white;
	}
}

.select.select-calendar {
	&:first-child {
		border-left: 0px !important;
	}

	p {
		color: map-get($colors, bg-chart);
		float: left;
		font-family: map-get($fonts, regular);
		font-size: 14px;
		margin-bottom: 0px;
		padding-left: 10px;
		padding-right: 10px;
	}

	.menu-calendar {
		float: left;
		width: 82px;
	}

	.input-group {
		box-shadow: none;
		max-height: 14px;
		min-height: auto;
		position: relative;

		label {
			height: 13px;
			line-height: 14px;
			top: 0px;
		}

		input {
			color: map-get($colors, bg-chart);
			font-size: 14px;
			height: 14px;
			line-height: 2;
			margin-left: 0px;
			opacity: 1;
		}

		.input-group__input {
			background-color: transparent !important;
			box-shadow: none;
			height: 14px;
			min-height: 14px;
		}
	}
}

.header-booking-data {
	.input-group {
		height: 31px;
		min-height: 31px;

		&__input {
			height: 31px;
		}
	}
}

.tasks-calendar-header {
	.select {
		.input-group {
			box-shadow: none;
			max-height: 13px;
			min-height: 1px;

			.input-group__input {
				background-color: transparent;
				height: 13px;
				min-height: 13px;
			}

			.input-group__selections {
				justify-content: center;
				margin-right: 0px;
				padding-left: 7px;

				&__comma {
					color: map-get($colors, bg-chart) !important;
					padding-right: 0px;
				}
			}

			.material-icons {
				padding: 0px;
				width: 15px;
			}

			label {
				color: map-get($colors, bg-chart) !important;
				height: 13px;
				line-height: 13px;
				margin-left: 0px;
				text-align: center;
				top: 14px;
			}
		}
	}
}

.default-skyblue {
	background-color: map-get($colors, default-skyblue) !important;
	border-color: map-get($colors, default-skyblue) !important;
}

.checkin-tabs {
	.tabs {
		&__bar {
			border-bottom: 1px solid map-get($colors, e-bg-icon);
			border-color: map-get($colors, e-bg-icon) !important;
			height: 38px;
		}

		&__slider {
			height: 3px;
		}

		&__item {
			color: map-get($colors, blue-title) !important;
			font-size: map-get($sizes, fourteen);
			text-transform: none;

			&.tabs__item--active {
				font-family: map-get($fonts, semibold);
			}
		}
	}

	&-modal {
		.tabs__bar {
			height: 60px;
		}

		.tabs__item {
			font-size: 18px;
		}
	}
}

.tabs__wrapper {
	margin: 0px !important;
}

.tag-menu-modal {
	.menu__activator {
		height: 100%;
	}
}

.tag-menu-header {
	border-top-left-radius: 10px;
	border-top-right-radius: 10px;

	.list__tile {
		height: 36px;
		padding: 0px 16px;
	}
}

.tag-menu-body {
	border-bottom-left-radius: 10px;

	.list__tile {
		height: auto;
		padding: 1.3px 16px;
	}
}

.tag-menu-sidebar {
	.list__tile {
		height: 31px;
		padding: 3px;
	}
}

.tag-menu-content {
	background-color: rgba($color: #ffffff, $alpha: .96);
	border-radius: 10px;
	box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, .4);
	height: fit-content;
	overflow: visible;

	&:after,
	&:before {
		border-bottom: 12px solid transparent;
		border-right: 13px solid rgba(255, 255, 255, .96);
		border-top: 12px solid transparent;
		bottom: 0px;
		content: '';
		display: inline-block;
		height: 0px;
		left: -13px;
		margin: auto 0;
		position: absolute;
		top: 0px;
	}

	&:before {
		border-bottom-width: 15px;
		border-right-color: rgba(0, 0, 0, .15);
		border-right-width: 16px;
		border-top-width: 15px;
		left: -16px;
	}

	&.new-booking {
		height: auto;
	}

	&.none {
		display: none;
	}
}

.width-auto {
	width: auto;

	input {
		align-self: center;
		height: 30px;
		width: 80px;
	}
}

.width-60 {
	width: 60%;

	input {
		align-self: center;
		height: 30px;
		width: 80px;
	}
}

.basis-30 {
	flex-basis: 30%;

	input {
		align-self: center;
		height: 30px;
		width: 80px;
	}
}

.basis-70 {
	flex-basis: 70%;
}

.print {
	&-no-show {
		@media print {
			display: none;
		}
	}

	&-width {
		@media print {
			padding: 0px !important;
		}
	}
}

.action-btn {
	.btn__content {
		padding: 0px;
	}
}

.pos-tabs {
	.tabs__container {
		right: 0px;
		width: 300px;
	}
}

.pos-tabs-left {
	.tabs__container {
		left: 0px;
		width: 300px;
	}
}

.input-total {
	input {
		padding-left: 0px !important;
		text-align: center;
	}
}

.radio-group-transparent {
	.input-group__input {
		background-color: transparent;
		box-shadow: none;

		.input-group {
			box-shadow: none;
		}

		.input-group label {
			color: map-get($map: $colors, $key: realtime-label);
			font-size: map-get($map: $sizes, $key: fourteen);
		}

		.icon {
			color: map-get($map: $colors, $key: default-skyblue) !important;
		}
	}
}

.radio-check-group {
	margin-bottom: 20px;

	.icon {
		display: none;
	}

	label {
		color: map-get($colors, form-prefix);
		font-family: map-get($fonts, regular) !important;
		font-size: map-get($sizes, fourteen) !important;
		left: 0px !important;
	}

	.input-group__input {
		background-color: transparent;
	}

	.input-group--selection-controls {
		background-color: white;
		margin-right: 20px;
	}

	.input-group--active {
		label {
			color: white !important;
		}

		.input-group__input {
			background-color: map-get($colors, default-skyblue);
		}
	}
}

.position-relative {
	& > div > div {
		position: relative !important;
	}
}

.btn-success {
	background-color: map-get($colors, button-create) !important;
	min-width: 100%;
}

.btn-grey {
	background-color: map-get($colors, label-sales) !important;
}

.btn-darkblue {
	background-color: #3b9afc !important;
	min-width: 100%;
}

.report-container > div {
	position: relative !important;
}

.caption-checkbox {
	.input-group__input {
		height: 30px;
	}

	.input-group__details {
		display: none;
	}
}

.menu-td-content {
	.list__tile__title {
		font-size: map-get($sizes, eleven);
	}
}

.btn-action-bar {
	.btn__content {
		justify-content: flex-start;
		padding: 0px 1px;
	}
}

.menu-layout {
	.list {
		padding: 0px;
	}

	.avatar {
		height: 14px !important;
		min-width: 25px;
		width: 21px !important;

		img {
			border-radius: 0px;
		}
	}

	.list__tile {
		height: 30px;
		opacity: .6;

		&__title {
			color: map-get($colors, text-login);
			font-size: map-get($sizes, fourteen);
		}

		&:hover {
			opacity: 1;
		}
	}

	.active {
		.list__tile {
			opacity: 1;
		}
	}
}

.filter-select-slot {
	.input-group__selections {
		margin-right: 0px;
		padding-left: 10px;
	}

	.input-group__append-icon {
		padding: 0px;
		width: 16px;
	}

	.avatar {
		height: 16px !important;
		margin-right: 5px;
		width: 16px !important;
	}
}

.menu__content--select {
	.avatar {
		height: 16px !important;
		margin-right: 5px;
		min-width: auto;
		width: 16px !important;
	}
}

.input-group.input-border-inset.input-table .input-group__input input {
	padding-left: 0px;
	text-align: center;
}

.rate-select {
	&.input-group {
		box-shadow: none;
		min-height: 25px !important;
	}
	.input-group__input {
		height: 25px;
	}
}

.input-rate-table {
	&.input-group.input-border-inset .input-group__input input {
		padding: 0;
		text-align: center;
	}
}

.type-room-select {
	min-height: 20px !important;
	.input-group__input {
		height: 30px;
	}
}

.slide-fade-leave-active,
.slide-fade-enter-active,
.fade-leave-active,
.fade-enter-active {
	transition-duration: 0.2s;
  	transition-property: transform, opacity;
  	transition-timing-function: cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to {
	opacity: 0;
	transform: translateX(20px);
}

.fade-enter, .fade-leave-to {
	opacity: 0;
	transform: translateY(20px);
}

.field {

		div.input-group {
		min-height: 25px !important;

		.input-group__input {
			height: 25px !important;
		}
	}
}

.active-input {

	.input-group__input {
		background-color: map-get($colors, default-skyblue) !important;
	}

	.input-group input {
		color: white !important;
		font-weight: map-get($weights, w-five);
		opacity: 1;
	}
}

.filter-list {
	color: map-get($colors, default-button-color);
	display: flex;

	button.btn {
		background-color: white !important;
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);
		color: map-get($colors, default-button-color);
		height: 40px;
		margin-right: 14px;

		&.active {
			background-color: map-get($colors, default-skyblue) !important;
			color: white;
		}
	}
}

.input-button {
	color: red;
	
	.input-group.input-border-inset {
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);
		
		.input-group__input input {
			box-shadow: none;
		}
	}
}

.label-title {
	font-family: map-get($fonts, medium);
	font-size: map-get($sizes, sixteen);
	margin-bottom: 10px;
}

.section-spacer {
	border: 1px solid map-get($colors, e-bg-icon);
}

.mask {
	cursor: pointer !important;
	max-width: 245px;

	.input-group.input-border-inset.input-group--disabled {
		opacity: 1;
	}
}

table.special-width-col {

	thead tr th {
		max-width: 150px;
		width: 100%;
	}
	
	thead tr th:last-child {
		width: 150px;
	}
}

.filters-by-time {
	color: map-get($colors, default-button-color);
	display: inline-flex;
	width: calc(102px * 2);

	button.btn {
		background-color: white !important;
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);
		color: map-get($colors, default-button-color);
		font-size: map-get($sizes, fourteen) !important;
		height: 40px;
		margin-left: 14px;
		max-width: 73px;

		&.activeBtn {
			background-color: map-get($colors, default-skyblue) !important;
			color: white;
		}
	}
}

.booking-menu-actions {
	border-radius: 5px;

	.list {
		padding: 0;

		li {
			border-bottom: 1px solid map-get($colors, border-menu-item);
			height: 30px;

			.list__tile {
				height: inherit;
				padding: 0 6px;

				.list__tile__action {
					min-width: 36px;
				}

				.list__tile__title {
					font-size: map-get($sizes, twelve);
				}
			}
		}
	}
}

.block-checkbox {

	&.input-group {
		box-shadow: none;
	}
	.input-group__input {
		background-color: transparent;
	}
}
</style>



// WEBPACK FOOTER //
// App.vue?c650697c